import { Heading } from '../../../components/typography/heading/Heading';
import Title from '../../../components/typography/title/Title';
import ScrollerRenderProp from '../../../utils/ScrollerRenderProp';
import IconButton from '../../atoms/iconButton/IconButton';
import { ArrowRight } from '../../atoms/icons';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useMedia } from 'react-use';

const SizeGuideTable = React.forwardRef(
  (
    {
      tableTitle,
      table,
      radioGroupComponent,
      customStyles,
      sizeGuide,
      newSizeGuide,
      ...rest
    },
    ref,
  ) => {
    const iconRegular = () => <ArrowRight width="42" height="22" />;
    const isWide = useMedia('(min-width: 810px)', true);

    return (
      <ScrollerRenderProp
        isExist={true}
        isWide={isWide}
        sizeGuide={sizeGuide}
        newSizeGuide={newSizeGuide}
        customClasses={{
          range: customStyles.range,
          field: customStyles.field,
        }}
      >
        {({ blockRef, scrollTo, isScrollShow, percentageOfScroll }) => {
          const isVisibleStart =
            Math.floor(percentageOfScroll) === 0 && customStyles.hiddenArrow;
          const isVisibleEnd =
            Math.floor(percentageOfScroll) >= 100 && customStyles.hiddenArrow;

          return (
            <div
              className={
                isScrollShow
                  ? customStyles.scrollerWrapperMobile
                  : customStyles.scrollerWrapperDesktop
              }
            >
              <div
                className={customStyles.tableRadioAndTitleWrapper}
                onWheel={(e) => {
                  e.stopPropagation();
                }}
              >
                <div className={customStyles.tableTitleWrapper}>
                  <Title>
                    <Heading className={customStyles.tableTitle} as="h2">
                      {tableTitle}
                    </Heading>
                  </Title>
                  {isScrollShow && (
                    <div className={customStyles.arrowBlock}>
                      <IconButton
                        style={{
                          transform: 'rotate(180deg)',
                        }}
                        className={isVisibleStart}
                        color="primary"
                        iconRegular={iconRegular}
                        iconHover={iconRegular}
                        iconActive={iconRegular}
                        onClick={() => scrollTo('decr')}
                        {...rest}
                      />
                      <IconButton
                        className={isVisibleEnd}
                        color="primary"
                        iconRegular={iconRegular}
                        iconHover={iconRegular}
                        iconActive={iconRegular}
                        onClick={() => scrollTo('inc')}
                        {...rest}
                      />
                    </div>
                  )}
                </div>
                {radioGroupComponent && radioGroupComponent}
              </div>
              <Table
                newTable={table}
                ref={blockRef}
                customStyles={customStyles}
              />
            </div>
          );
        }}
      </ScrollerRenderProp>
    );
  },
);

const Table = React.forwardRef(({ newTable, customStyles }, ref) => {
  const [hideShadow, setHideShadow] = useState(false);

  const tableWrapperWidth =
    ref.current && ref.current.getBoundingClientRect().width;
  const tableWidth =
    ref.current &&
    ref.current.querySelector('table').getBoundingClientRect().width;

  const handleScroll = (event) => {
    const { scrollLeft } = event.target;

    const offsetWidth = 5;
    const hideShadow =
      Math.round(tableWidth) - Math.round(tableWrapperWidth) <
      Math.round(scrollLeft) + offsetWidth;

    setHideShadow(hideShadow);
  };

  useEffect(() => {
    if (!!tableWidth && !!tableWrapperWidth)
      setHideShadow(Math.round(tableWidth) <= Math.round(tableWrapperWidth));
  }, [newTable, ref.current]);

  return (
    <div className={customStyles.sizeGuideTable}>
      <div
        className={clsx(
          customStyles.tableWrapper,
          hideShadow && customStyles.tableNoFade,
        )}
        ref={ref}
        onScroll={handleScroll}
        style={{
          '--shadow-height':
            ref.current?.clientHeight && `${ref.current?.clientHeight}px`,
        }}
      >
        <table className={customStyles.table}>
          {newTable &&
            newTable.map((item, index) => {
              const maxLenght = newTable[0].length;
              return (
                <tr key={index} className={clsx(customStyles.tableRow)}>
                  {[
                    ...Object.values(item),
                    ...new Array(maxLenght - item.length),
                  ].map((val, key) => (
                    <td key={`column_${key}`} className={customStyles.tableColumn}>
                      {val}
                    </td>
                  ))}
                </tr>
              );
            })}
        </table>
      </div>
    </div>
  );
});

SizeGuideTable.propTypes = {
  tableTitle: PropTypes.string,
};

SizeGuideTable.defaultProps = {
  tableTitle: '',
};

export default SizeGuideTable;
